import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { escalationConfigurationFeature, EscalationConfigurationEffects } from './store';

export function provideConfigurationsFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(escalationConfigurationFeature),
    provideEffects(EscalationConfigurationEffects),
  ]);
}
